export default __webpack_public_path__ + "static/blog10-26ad1002a74898e7d6e62fb1a27d2158.jpg";